import { element } from 'prop-types';
import React, { useEffect } from 'react'
import './chat-modal.scss'

const addCountry=(locale)=>{
    let pais =''
    if(element){
        switch (locale){
            case 'es-CO':
                pais='Colombia';
                break;
            case 'es-BO':
                 pais='Bolivia';
                break;
            case 'es-DO':
                pais='República Dominicana';
                break;
            case 'es-EC':
                 pais='Ecuador';
                break;
            default:
                pais='';
        }
    }
    return pais
}
const ChatModal = () => {
    const haveChat = ["es-CO", "es-EC", "es-DO", "es-BO"]

    const initESW = function (gslbBaseURL) {
        embedded_svc.settings.displayHelpButton = true; //O falso
        embedded_svc.settings.language = 'ES'; //Por ejemplo, introduzca 'en' o 'en-US'

        window.embedded_svc.settings.defaultMinimizedText = 'Chat con un asesor'; //(Toma como valor predeterminado Sesión de chat con un experto)
        window.embedded_svc.settings.disabledMinimizedText = 'Asesor sin conexión'; //(Toma como valor predeterminado Agente sin conexión)

        window.embedded_svc.settings.loadingText = 'Cargando'; //(Toma como valor predeterminado Cargando)
        window.embedded_svc.settings.storageDomain = window.location.hostname; //(Establece el dominio para su desarrollo de modo que los visitantes puedan navegar por subdominios durante una sesión de chat)

        // Configuración para Chat
        //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
        // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
        // Returns a valid button ID.
        //};
        //embedded_svc.settings.prepopulatedPrechatFields = {}; //Establece la cumplimentación automática de los campos del formulario previo al chat
        //embedded_svc.settings.fallbackRouting = []; //Una matriz de identificadores de botones, de usuario o userId_buttonId
        //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Toma como valor predeterminado la opción Contacto)
        embedded_svc.settings.enabledFeatures = ['LiveAgent'];
        embedded_svc.settings.entryFeature = 'LiveAgent';

        embedded_svc.settings.extraPrechatFormDetails = [
            { "label": "RecordTypeId", "value": "0123j000000XA07AAG", "displayToAgent": true },
            { "label": "Nombre", "transcriptFields": ["GRF_Nombre_Prechat__c"] },
            { "label": "Apellidos", "transcriptFields": ["GRF_Apellidos_Prechat__c"] },
            { "label": "Correo electrónico", "transcriptFields": ["GRF_Correo_Prechat__c"] },
            { "label": "Tipo de identificación", "transcriptFields": ["GRF_Tipo_Documento_Prechat__c"] },
            { "label": "Número de Identificación", "transcriptFields": ["GRF_Numero_Documento_Prechat__c"] },
            { "label": "Ciudad", "transcriptFields": ["GRF_Ciudad_Prechat__c"] },
            { "label": "Teléfono", "transcriptFields": ["GRF_Telefono_Prechat__c"] },
            {"label":"País", "transcriptFields": ["GRF_Pais__c"],"value": addCountry(process.env.LOCALE),"displayToAgent": true}];

        embedded_svc.settings.extraPrechatInfo = [
            {
                "entityName": "Contact",
                "saveToTranscript": "ContactId",
                "showOnCreate": true,
                "entityFieldMaps": [{
                    "fieldName": "FirstName",
                    "doFind": false,
                    "doCreate": false,
                    "label": "Nombre"
                }, {
                    "fieldName": "LastName",
                    "doFind": false,
                    "doCreate": false,
                    "label": "Apellidos"
                }, {
                    "fieldName": "Email",
                    "doFind": true,
                    "doCreate": false,
                    "label": "Correo electrónico"
                }, {
                    "fieldName": "GRF_NumeroIdentificacion__c",
                    "doFind": false,
                    "doCreate": false,
                    "label": "Número de Identificación"
                }]
            }];

        embedded_svc.init(
            'https://grupofamilia.my.salesforce.com',
            'https://grupofamilia.secure.force.com/chatPequenin',
            gslbBaseURL,
            '00D3j0000001yNQ',
            'GRF_B2CPequenin',
            {
                baseLiveAgentContentURL: 'https://c.la4-c3-ia2.salesforceliveagent.com/content',
                deploymentId: '5723j000000TWp0',
                buttonId: '5733j000000TXBO',
                baseLiveAgentURL: 'https://d.la4-c3-ia2.salesforceliveagent.com/chat',
                eswLiveAgentDevName: 'GRF_B2CPequenin',
                isOfflineSupportEnabled: false
            }
        );
    };
    
    useEffect(() => {
        if (haveChat.includes(process.env.LOCALE)) {
            if (!window.embedded_svc) {
                var s = document.createElement('script');
                s.setAttribute('src', 'https://grupofamilia.my.salesforce.com/embeddedservice/5.0/esw.min.js');
                s.onload = function () {
                    initESW(null);
                };
                document.body.appendChild(s);

            } else {
                initESW('https://service.force.com');                
            }

        }
    }, [])
       
    return <></>
}

export default ChatModal
